import I18n from '../../../lib/i18n';

export const isCurrencyPlaceOnRight = (): boolean => {
  const priceFormat = I18n.t('prices.currency.format');

  return priceFormat.indexOf('%u') > priceFormat.indexOf('%n');
};
